import React, { useEffect,useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHtml5, faCss3Alt, faJs, faNodeJs, faVuejs, faReact, faLaravel, faBootstrap, faPhp } from '@fortawesome/free-brands-svg-icons';
import { faArrowRight, faArrowLeft} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import "../../App.css"
import axiosInstance from '../../axiosInstance';

const About = () => {

  const [aboutContent, setAboutContent] = useState({
    description: '',
    principles: []
  });

  useEffect(() => {
    fetchAboutContent();
  }, []);

  const fetchAboutContent = async () => {
    try {
      const response = await axiosInstance.get('/about');
      setAboutContent(response.data);
    } catch (error) {
      console.error('Error fetching about content:', error);
    }
  };
  return (
    <div className='max-w-7xl mx-auto px-4 py-12 max-sm:px-8'>
      <div className='max-sm:w-full w-[60%] max-md:w-[80%]'>
        <ol className="border-s-4 border-neutral-300 dark:border-neutral-500">
          <li>
            <div className="flex-start flex items-center ">
              <div className="-ms-[9px] -mt-2 me-3 flex h-4 w-4 items-center justify-center rounded-full bg-gray-900 dark:bg-[rgb(211,219,236)] m-4">
                <div className='h-2 w-2 bg-[rgb(211,219,236)] dark:bg-gray-900 rounded-full'></div> 
              </div>
              <h4 className="-mt-2 text-3xl font-light text-gray-900 dark:text-[rgb(211,219,236)]">Who am I?</h4>
            </div>
            <div className="mb-6 ms-4 mt-4">
              <p className="mb-3 text-gray-900 dark:text-[rgb(211,219,236)] tracking-wide leading-7 font-light">
                {aboutContent.description}
              </p>
            </div>
          </li>

          <li className='pt-6'>
            <div className="flex-start flex items-center pt-2">
              <div className="-ms-[9px] -mt-2 me-3 flex h-4 w-4 items-center justify-center rounded-full bg-gray-900 dark:bg-[rgb(211,219,236)]">
                <div className='h-2 w-2 bg-[rgb(211,219,236)] dark:bg-gray-900 rounded-full'></div> 
              </div>
              <h4 className="-mt-2 text-3xl font-light text-gray-900 dark:text-[rgb(211,219,236)]">Skills</h4>
            </div>
            <div className="mb-6 ms-4 mt-4">
              <p className="mb-3 text-gray-900 dark:text-[rgb(211,219,236)] tracking-wide">
                This is a list of the technologies that I have actually worked with in different projects.
              </p>
              <div className='grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 max-sm:gap-2'>
                <div className='flex items-center justify-center' title='HTML'>
                  <FontAwesomeIcon icon={faHtml5} className='text-5xl sm:text-7xl text-gray-900 dark:text-[rgb(211,219,236)]' />
                </div>
                <div className='flex items-center justify-center' title='CSS'>
                  <FontAwesomeIcon icon={faCss3Alt} className='text-5xl sm:text-7xl text-gray-900 dark:text-[rgb(211,219,236)]' />
                </div>
                <div className='flex items-center justify-center' title='Tailwind'>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 128 128"
                    className='w-10 h-10 sm:w-16 sm:h-16 text-gray-900 dark:text-[rgb(211,219,236)]'
                  >
                    <path
                      d="M64.004 25.602c-17.067 0-27.73 8.53-32 25.597 6.398-8.531 13.867-11.73 22.398-9.597 4.871 1.214 8.352 4.746 12.207 8.66C72.883 56.629 80.145 64 96.004 64c17.066 0 27.73-8.531 32-25.602-6.399 8.536-13.867 11.735-22.399 9.602-4.87-1.215-8.347-4.746-12.207-8.66-6.27-6.367-13.53-13.738-29.394-13.738zM32.004 64c-17.066 0-27.73 8.531-32 25.602C6.402 81.066 13.87 77.867 22.402 80c4.871 1.215 8.352 4.746 12.207 8.66 6.274 6.367 13.536 13.738 29.395 13.738 17.066 0 27.73-8.53 32-25.597-6.399 8.531-13.867 11.73-22.399 9.597-4.87-1.214-8.347-4.746-12.207-8.66C55.128 71.371 47.868 64 32.004 64zm0 0"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <div className='flex items-center justify-center' title='Bootstrap'>
                  <FontAwesomeIcon icon={faBootstrap} className='text-5xl sm:text-7xl text-gray-900 dark:text-[rgb(211,219,236)]' />
                </div>
                <div className='flex items-center justify-center' title='Javascript'>
                  <FontAwesomeIcon icon={faJs} className='text-5xl sm:text-7xl text-gray-900 dark:text-[rgb(211,219,236)]' />
                </div>
                <div className='flex items-center justify-center' title='Vuejs'>
                  <FontAwesomeIcon icon={faVuejs} className='text-5xl sm:text-7xl text-gray-900 dark:text-[rgb(211,219,236)]' />
                </div>
                <div className='flex items-center justify-center' title='Reactjs'>
                  <FontAwesomeIcon icon={faReact} className='text-5xl sm:text-7xl text-gray-900 dark:text-[rgb(211,219,236)]' />
                </div>
                <div className='flex items-center justify-center' title='Php'>
                  <FontAwesomeIcon icon={faPhp} className='text-5xl sm:text-7xl text-gray-900 dark:text-[rgb(211,219,236)]' />
                </div>
                <div className='flex items-center justify-center' title='Laravel'>
                  <FontAwesomeIcon icon={faLaravel} className='text-5xl sm:text-7xl text-gray-900 dark:text-[rgb(211,219,236)]' />
                </div>
                <div className='flex items-center justify-center' title="NodeJs">
                  <FontAwesomeIcon icon={faNodeJs} className='text-5xl sm:text-7xl text-gray-900 dark:text-[rgb(211,219,236)]' />
                </div>
                <div className='flex items-center justify-center' title="Flutter">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 128 128"
                    className='w-10 h-10 sm:w-16 sm:h-16 text-gray-900 dark:text-[rgb(211,219,236)]'
                  >
                    <g fill="currentColor">
                      <path d="M12.3 64.2L76.3 0h39.4L32.1 83.6zM76.3 128h39.4L81.6 93.9l34.1-34.8H76.3L42.2 93.5z" />
                    </g>
                    <path fill="currentColor" d="M81.6 93.9l-20-20-19.4 19.6 19.4 19.6z" />
                    <path fill="currentColor" d="M115.7 128L81.6 93.9l-20 19.2L76.3 128z" />
                    <path fill="currentColor" d="M61.6 113.1l30.8-8.4-10.8-10.8z" />
                  </svg>
                </div>
              </div>
            </div>
          </li>

          <li className='pt-6'>
            <div className="flex-start flex items-center pt-2">
              <div className="-ms-[9px] -mt-2 me-3 flex h-4 w-4 items-center justify-center rounded-full bg-gray-900 dark:bg-[rgb(211,219,236)]">
                <div className='h-2 w-2 bg-[rgb(211,219,236)] dark:bg-gray-900 rounded-full'></div> 
              </div>
              <h4 className="-mt-2 text-3xl font-light text-gray-900 dark:text-[rgb(211,219,236)]">My Principles</h4>
            </div>
            <div className="ms-4 mt-4 pb-5">
              <ul>
                {aboutContent.principles.map((principle, index) => (
                  <li key={index}>
                    <h4 className='text-xl font-semibold text-gray-900 dark:text-[rgb(211,219,236)] pb-4 underline'>{principle.title}</h4>
                    <p className="mb-3 text-gray-900 dark:text-[rgb(211,219,236)] tracking-wide leading-7 font-light">
                      {principle.description}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </li>
        </ol>
      </div>
      <div className='flex items-center justify-between pt-6'>
        <Link to='/' className="mb-4 nav-link py-2 dark:text-white text-[#111318] rounded">
          <FontAwesomeIcon icon={faArrowLeft} className='text-lg pr-1' /> Home
        </Link>
        <Link to='/projects' className="mb-4 nav-link py-2 dark:text-white text-[#111318] rounded">
          Projects <FontAwesomeIcon icon={faArrowRight} className='text-lg pr-1' /> 
        </Link>
      </div>
    </div>
  );
};

export default About
